import React, { useContext } from 'react';
import ThemeContext from '../context/ThemeContext';
import './style/Contact.css';
import './style/dark-mode/ContactDark.css';

function Contact() {
    const {theme} = useContext(ThemeContext);

    return (
        <div id='contact' className={`contact-container contact-container-${theme}`}>
            <form action="https://formsubmit.co/ebionarduche77@gmail.com" method="POST">
                <h1>CONTATO</h1>
                <input type="hidden" name="_captcha" value="false" />
                <input type="hidden" name="_next" value="https://my-portfolio-ebionarduche.vercel.app/" />
                <label htmlFor="nome">
                    Nome:
                    <input type="text" name="name" placeholder="Escreva seu nome aqui"required />
                </label>
                <label htmlFor="email">
                    Email:
                    <input type="email" name="email" placeholder="Escreva seu email aqui" required />
                </label>

                <label htmlFor="">
                    Mensagem:
                    <textarea name="message" placeholder="Escreva sua mensagem aqui" />
                </label>
                <button type="submit">Enviar</button>
            </form>    
        </div>
    );
}

export default Contact;


